import React, { useState } from 'react';

const DEFAULT_IMAGES = {
  'Corte a Laser': '/assets/corte_laser.png',
  'Metaleira': '/assets/metaleira.png',
  'Guilhotinas': '/assets/guilhotina.png',
  'Calandras': '/assets/calandra.png',
  'Solda Laser': '/assets/solda_laser.png'
};

const CategoryOption = ({ category }) => (
  <div className="flex items-center space-x-2">
    {category.image_url && (
      <img 
        src={category.image_url} 
        alt={category.name} 
        className="w-6 h-6 object-cover rounded"
      />
    )}
    <span>{category.name}</span>
  </div>
);

const CategoryEditor = ({ categories }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image: null,
    imagePreview: null
  });

  const getDefaultImage = (categoryName) => {
    return DEFAULT_IMAGES[categoryName] || DEFAULT_IMAGES['Corte a Laser'];
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setFormData({
      name: category.name,
      description: category.description || '',
      image: null,
      imagePreview: category.image_url
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        image: file,
        imagePreview: URL.createObjectURL(file)
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedCategory) return;

    const data = new FormData();
    data.append('category[description]', formData.description);
    if (formData.image) {
      data.append('category[image]', formData.image);
    }

    try {
      const response = await fetch(`/admin/categories/${selectedCategory.id}`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: data
      });

      if (!response.ok) throw new Error('Failed to update category');
      alert('Categoria atualizada com sucesso!');
      
      // Refresh the page to show updated data
      window.location.reload();
    } catch (error) {
      console.error('Error updating category:', error);
      alert('Erro ao atualizar categoria. Por favor, tente novamente.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Editar Categorias
          </h1>
          <p className="text-gray-600">
            Selecione uma categoria para editar seus detalhes
          </p>
        </div>

        {/* Category Selection */}
        <div className="mb-8">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Categoria
          </label>
          <select
            value={selectedCategory?.id || ''}
            onChange={(e) => {
              const category = categories.find(c => c.id === parseInt(e.target.value));
              handleCategorySelect(category);
            }}
            className="w-full p-2 border rounded-lg"
          >
            <option value="">Selecione uma categoria...</option>
            {categories.map(category => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>

        {/* Edit Form */}
        {selectedCategory && (
          <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow space-y-6">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nome da Categoria
              </label>
              <input
                type="text"
                value={formData.name}
                className="w-full px-3 py-2 border rounded-md bg-gray-100 text-gray-700 cursor-not-allowed"
                disabled
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Descrição
              </label>
              <textarea
                value={formData.description}
                onChange={e => setFormData({ ...formData, description: e.target.value })}
                className="w-full px-3 py-2 border rounded-md"
                rows={4}
              />
            </div>

            {/* Current Image Display */}
            <div className="flex flex-col items-center pt-4 pb-6">
              <h3 className="text-lg font-medium text-gray-700 mb-4">
                Imagem Atual
              </h3>
              <div className="w-full max-w-2xl h-96 md:h-screen lg:h-screen relative bg-gray-50 rounded-lg overflow-hidden" style={{height: '600px'}}>
                <img
                  src={formData.imagePreview || selectedCategory.image_url || getDefaultImage(selectedCategory.name)}
                  alt={selectedCategory.name}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            {/* Image Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nova Imagem da Categoria
              </label>
              <div className="space-y-4">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="w-full"
                />
                <p className="text-sm text-gray-500">
                  Selecione uma nova imagem para atualizar a imagem atual
                </p>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-orange-500 text-white py-2 px-4 rounded-md hover:bg-orange-600 transition-colors"
            >
              Salvar Alterações
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default CategoryEditor; 